import { render, staticRenderFns } from "./AdaptedPhysicalActivities.vue?vue&type=template&id=7c4c0f7e"
import script from "./AdaptedPhysicalActivities.vue?vue&type=script&lang=js"
export * from "./AdaptedPhysicalActivities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports